import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { login as loginService } from '../services/authService';
import { saveToken, saveUser } from '../utils/storageUtils';

export const useLogin = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const { dispatch } = useAuthContext()

  const login = async (email, password) => {
        setIsLoading(true)
        setError(null)

    try {
        // Convert email to lowercase before sending to the service
        const lowerCaseEmail = email.toLowerCase();
        // console.log('Attempting login with email:', lowerCaseEmail); // Added log
        const response = await loginService( lowerCaseEmail, password );
        // console.log('Login service response:', response); // Added log

        saveUser(response.data.user);
        saveToken(response.data.token);
        dispatch({type: 'LOGIN', payload: response.data});
        setIsLoading(false);
        // console.log('Login successful'); // Added log
        return {success:response.success, message:response.message, role:response?.data?.user?.role}
    } catch (error) {
        // console.error('Login failed:', error); // Added log for the error object
        setIsLoading(false);
        if (error.response) {
            setError(error.response.data.message || 'An error occurred. Please try again.');
            // console.error('Login error response:', error.response); // Added log for response error
            return { success: false, message: error.response.data.message || 'An error occurred. Please try again.' };
          } else if (error.request) {
            setError('No response from the server. Please check your network connection.');
            //  console.error('Login error request:', error.request); // Added log for request error
            return { success: false, message: 'No response from the server. Please check your network connection.' };
          } else {
            setError('An unexpected error occurred. Please try again.');
            //  console.error('Login error unexpected:', error); // Added log for unexpected error
            return { success: false, message: 'An unexpected error occurred. Please try again.' };
          }
    }

  }

  return { login, isLoading, error }
}